import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';

@Component({
  selector: 'app-home-cta',
  templateUrl: './home-cta.component.html',
  styleUrls: ['./home-cta.component.scss'],
  imports: [ButtonModule, RippleModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeCtaComponent {
  createEventClick = output<void>();
  howItWorksClick = output<void>();

  protected onCreateEventClick(): void {
    this.createEventClick.emit();
  }

  protected onHowItWorksClick(): void {
    this.howItWorksClick.emit();
  }
}
